import { render, staticRenderFns } from "./CategoryCardFlat.vue?vue&type=template&id=62040482&scoped=true&"
import script from "./CategoryCardFlat.vue?vue&type=script&lang=ts&"
export * from "./CategoryCardFlat.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCardFlat.vue?vue&type=style&index=0&id=62040482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62040482",
  null
  
)

export default component.exports